import { useReducedMotion } from 'framer-motion';
import { useMemo } from 'react';
import useMediaQuery from './use-media-query';

/**
 * Hook to centralize animation preference logic
 * Combines user preferences with system preferences
 */
export default function useAnimationPreferences() {
  const isReducedMotion = useReducedMotion();
  const prefersReducedMotion = useMediaQuery('(prefers-reduced-motion: reduce)') || isReducedMotion;

  // Should animations be enabled based on both user settings and system preferences
  const shouldAnimate = useMemo(() => {
    return !prefersReducedMotion;
  }, [prefersReducedMotion]);

  // Animation variants based on preferences
  const animationVariants = useMemo(() => {
    if (prefersReducedMotion) {
      return {
        // Instant transitions for reduced motion
        fade: { duration: 0.01 },
        slide: { duration: 0.01, type: 'tween' },
        scale: { duration: 0.01, type: 'tween' },
      };
    }

    return {
      // Normal animation durations
      fade: { duration: 0.3 },
      slide: { duration: 0.4, type: 'spring', stiffness: 300, damping: 30 },
      scale: { duration: 0.2, type: 'spring', stiffness: 400, damping: 25 },
    };
  }, [prefersReducedMotion]);

  return {
    prefersReducedMotion,
    shouldAnimate,
    animationVariants,
  };
}
